//@service
import {bind,RepositoryInterface} from '@/service/utils'
export const reportService= {
  get reportRepository() {
    return bind(() => import('./report.repo'), RepositoryInterface);
  },
  get finalReportVotesRepository() {
    return bind(() => import('./finalReportVotes.repo'), RepositoryInterface);
  },
  get paymentNoNeedRepository() {
    return bind(() => import('./paymentNoNeed.repo'), RepositoryInterface);
  },
}
